import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const problems = [{
  title: 'Grupos mezclados de niveles',
  desc: 'Cuando conviven niños que recién arrancan con otros avanzados, la clase se desordena: unos se aburren y otros se frustran.'
}, {
  title: 'Falta de tiempo para planificar',
  desc: 'Entre el club y el día a día, terminás armando clases "sobre la marcha", repitiendo siempre lo mismo por falta de margen.'
}, {
  title: 'Miedo a lesiones y falta de orden',
  desc: 'Sin progresiones técnicas claras, sube el riesgo. Necesitás saber exactamente qué ejercicio va antes de cada acrobacia.'
}, {
  title: 'No saber cómo demostrar el progreso',
  desc: 'Cuesta explicarle a los padres por qué el niño sigue en el mismo aparato o demostrar con datos que realmente está avanzando.'
}];
export function Problem() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <span className="text-primary font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-170">
            El problema
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-black text-navy mb-4" data-id="element-171">
            ¿Te sentís identificado?
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-172">
            Si alguno de estos problemas te suena familiar, este sistema es para
            vos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-173">
          {problems.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-cream-dark/30 rounded-2xl p-6 sm:p-8 border border-gray-100 flex gap-4" data-id="element-174">
              <XCircle className="w-6 h-6 text-primary shrink-0 mt-1" data-id="element-175" />
              <div data-id="element-176">
                <h3 className="font-bold text-navy text-lg mb-2" data-id="element-177">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-178">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-179">
          <p className="font-bold text-navy text-lg" data-id="element-180">
            Si respondiste "sí" a alguna de estas…{' '}
            <span className="text-primary" data-id="element-181">tenemos la solución.</span>
          </p>
        </div>
      </div>
    </section>;
}